module.exports = __webpack_public_path__ + "assets/SquareByAdjMidpointsDetailed.7e74914eace3b0deab671a3d9801ad85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/SquareByAdjMidpointsDetailed.png
// module id = 565
// module chunks = 0